export const selectAllVersions = state => state.versions.allVersions
export const selectAllVersionsToSelect = state =>
  state.versions.allVersions.map(s => ({
    label: 'Versión ' + s.versionName,
    value: s.id,
    ...s,
  }))
export const selectLastVersion = state => state.versions.lastVersion
